import Vue from 'vue'

const bindingModule = {
    state: {
        bindingList: [],
        currentBinding: {}
    },
    mutations: {
        SET_BINDINGS (state, newVal) {
            state.bindingList = newVal
        },
        SET_CURRENT_BINDING (sate, newVal) {
            state.currentBinding = newVal
        }
    },
    getters: {
        getBindings (state) {
            return state.bindingList
        },
        getBinding (state) {
            return state.currentBinding
        }
    },
    actions: {
        async FETCH_BINDINGS (ctx) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Format',
                'getAllBindings'
            )

            ctx.commit('SET_BINDINGS', result.data)
        },
        async FETCH_BINDING (ctx, id) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Format',
                'getBindingsForId',
                id
            )

            ctx.commit('SET_CURRENT_BINDING', result.data)
        }
    }
}

export const state = bindingModule.state
export const getters = bindingModule.getters
export const mutations = bindingModule.mutations
export const actions = bindingModule.actions
